const pulseSlotMatcher = ({ pulseMin, pulseStart, pulseRepeat }, postCount) => {

  const firstSlot = Math.max(pulseMin, pulseStart);

  if (postCount <= firstSlot) {
    // Show after last.
    return idx => idx === postCount - 1;
  }

  if (pulseRepeat === 0) {
    return idx => idx + 1 === firstSlot;
  }

  return idx => {
    const offset = idx + 1 - firstSlot;

    return offset >= 0 && offset % pulseRepeat === 0;
  };
};

export default pulseSlotMatcher;
